window.addEventListener('load', () => {
  const navTabs = document.querySelectorAll('[data-tab-nav]');

  navTabs.forEach((navTab) => {
    const tabsParent = navTab.closest('[data-tab-parent]');
    const navTabGroupTarget = navTab.getAttribute('data-tab');
    const navTabItems = navTab.querySelectorAll('[data-tablink]');
    const tabContentWrapper = document.querySelector(`[data-tab-wrapper][data-tab="${navTabGroupTarget}"]`);
    const tabContentElems = tabContentWrapper.querySelectorAll('[data-tab-content]');
    const firstTabContentElemHeight = `${tabContentElems[0].clientHeight}px`;

    // Set height of first tab
    tabContentWrapper.style.height = firstTabContentElemHeight;

    // Open specific tab
    navTabItems.forEach((el, index) => {
      el.addEventListener('click', () => {
        tabsParent.querySelectorAll('[data-tablink]').forEach((elem) => {
          elem.classList.remove('is-active');
        });
        tabsParent.querySelectorAll('[data-tab-content]').forEach((contentElem) => {
          contentElem.classList.add('is-hidden');

          setTimeout(() => contentElem.classList.remove('is-active'), 100);
        });

        const targetTabContent = tabContentElems[index];

        setTimeout(() => {
          targetTabContent.classList.add('is-active');

          const tabContentHeight = `${targetTabContent.clientHeight}px`;
          tabContentWrapper.style.height = tabContentHeight;

          setTimeout(() => targetTabContent.classList.remove('is-hidden'), 100);
        }, 100);

        el.classList.add('is-active');
      });
    });
  });
});
